export const titleText = "The mint is closed";
export const subtitleText = "The Gods cannot bless you with an Eternal Viking";
export const ctaOneText = "Buy from Opensea";
export const ctaTwoText = "Check NFT Qualification";